import DashboardCircle from './DashboardCircle'

export default class DashboardCircles {
  constructor(el) {
    window.dashboard_circles = this;

    this.$ = $(el);
    this.total = this.$.data("total");
    this.circles = [];
    this.$.find(".dashboard-circle").each(((_this) => {
      return function(i, el) {
        return _this.circles.push(new DashboardCircle(el, _this.total));
      };
    })(this));

    $(window).on("resize", ((_this) => {
      return () => {
        var circle, j, len, ref, results;
        ref = _this.circles;
        results = [];
        for (j = 0, len = ref.length; j < len; j++) {
          circle = ref[j];
          results.push(circle.resize());
        }
        return results;
      };
    })(this));
  }
}
